import SuggestionItem from './SuggestionItem'

export default SuggestionItem



// WEBPACK FOOTER //
// ./src/components/SearchFilterInput/components/SuggestionItem/index.js